import { func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withProps from 'recompose/withProps'

import View from '../View'


const MethodButtons = scope(
  consumeProps({
    updateUsing: func.isRequired,
  }),

  withProps(({ updateUsing }) => ({
    options: [
      { key: 'dot', name: '點', onClick: () => updateUsing('method', 'dot') },
      { key: 'rect', name: '矩形', onClick: () => updateUsing('method', 'rect') },
      { key: 'slash', name: '右上', onClick: () => updateUsing('method', 'slash') },
      { key: 'fill', name: '向下填滿', onClick: () => updateUsing('method', 'fill') },
    ],
  })),

  exposeProps([
    'options',
  ]),
)(View)

MethodButtons.displayName = 'MethodButtons'

export default MethodButtons



// WEBPACK FOOTER //
// ./src/components/RangeEditor/SettingButtons/MethodButtons/index.js